module.exports = __webpack_public_path__ + "static/media/image03.c2cbe328.png";